import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth0Service } from 'src/app/auth/auth0.service';
import { UserService } from 'src/app/shared/services/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  isMedigi;
  isOutsourcing;
  isMedshorts;
  isSellerDirect = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private auth0: Auth0Service,
  ) {}

  async ngOnInit() {
    if (this.auth0.loggedIn) {
      this.navigate();
      return;
    }
    if (environment.supplierConfig['logout_redirect']) {
      window.location.href = environment.supplierConfig['logout_redirect'];
    }
    let msClient = await this.userService._getMsClient();
    this.isSellerDirect = msClient?.use_direct === 1;
    this.isOutsourcing =
      environment.clientDomains.outsourcingDomian === window.location.host;
    this.isMedshorts =
      environment.clientDomains.medshortsDomain === window.location.host;
    this.isMedigi =
      !this.isSellerDirect && !this.isOutsourcing && !this.isMedshorts;
  }

  navigate() {
    this.userService.getMe().subscribe(result => {
      if (result.data.is_buyer) {
        this.router.navigate(['/catalog']);
      }
      if (result.data.is_seller) {
        this.router.navigate(['/seller-home']);
      }
    });
  }
}
